export default "__VITE_ASSET__gie9_Vpd__"